// export const API_BASE_URL = 'https://cms.coachgenie.in/API';
// export const APP_BASE_URL = 'https://cms.coachgenie.in';
export const API_BASE_URL = 'https://insurance.webtrixsolutions.in/API';
export const APP_BASE_URL = 'https://insurance.webtrixsolutions.in';
// export const API_BASE_URL = 'http://localhost/webtrix_24_BE';
export const APP_NAME = "Webtrix24 CRM";
// export const API_BASE_URL = 'https://rental.webtrixsolutions.in/API';
// export const APP_BASE_URL = 'https://rental.webtrixsolutions.in';

// export const API_BASE_URL = 'https://ankur.webtrixsolutions.in/admin/API';
// export const APP_BASE_URL = 'https://ankur.webtrixsolutions.in/admin';

// export const API_BASE_URL = "https://"+window.location.host+"/API";
// export const APP_BASE_URL = "https://"+window.location.host+"";
// export const API_BASE_URL = 'https://www.webtrix24.com/admin/API';
// export const APP_BASE_URL = 'https://www.webtrix24.com/admin';
export const APP_ID = '1903801147210363';
export const COMPANY_WHATSAPP_NUMBER = '941111572415684';